"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispachShippingOfferDialogResultEvent = dispachShippingOfferDialogResultEvent;
var _checkoutUtils = require("@ori/checkout-utils");
var _constants = require("../constants");
/**
 * Trigger event to navigate to next step in legacy code without checking
 * the applied shipping offer again. No need to update the displayed delivery
 * step here, as we navigate away from it anyway.
 */
function dispachShippingOfferDialogResultEvent(detail) {
  const dispatchDialogResultEvent = (0, _checkoutUtils.getShippingOfferDialogResultEventDispatcher)(_constants.APP_NAME);
  dispatchDialogResultEvent(detail);
}